import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import { useGame } from '@/app/providers/GameContextProvider';
import { useGlobalPopup } from '@/app/providers/GlobalPopupProvider';
import { useGameModeSettingsContext } from '@/app/providers/GameModeSettingsProvider';
import { HazardModeSettings, CustomModeSettings } from '@/lib/types/common/GameModeAdvancedSettings';
import InputFFXIV from '../../../InputFFXIV';
import TooltipWithIconFFXIV from '@/app/components/TooltipWithIconFFXIV';

const HazardsPerRoundSelector: React.FC = () => {
    const { t } = useTranslation();
    const { room, gameState } = useGame();
    const { showPopup } = useGlobalPopup();
    const { settings, updateSettings, isGameMaster } = useGameModeSettingsContext();

    if (!room || !gameState) return null;

    const value = (settings as HazardModeSettings | CustomModeSettings).hazardsPerRound ?? 1;

    const handleHazardsChange = (newCount: number) => {
        if (isGameMaster) {
            updateSettings({ hazardsPerRound: newCount } as Partial<HazardModeSettings>);
        } else {
            showPopup({
                type: 'error',
                message: t('lobby.onlyGameMasterCan'),
            });
        }
    };

    return (
        <div className="flex gap-4 items-center">
            <div className="flex gap-3 items-center">
                <div className="text-[#EEE1C5] text-shadow-border shadow-black text-lg">
                    {t('game.config.advancedSettings.hazardsPerRound')}
                </div>
                <InputFFXIV
                    value={value}
                    onChange={(newValue) => handleHazardsChange(newValue)}
                    min={1}
                    max={10}
                    className="!w-[40px]"
                />
            </div>
            <TooltipWithIconFFXIV text={t('game.config.advancedSettings.hazardsPerRoundTooltip')} />
        </div>
    );
};

export default HazardsPerRoundSelector;
